var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 13.8043C5.06016 13.8043 2.66683 11.411 2.66683 8.47099C2.66683 5.53099 5.06016 3.13765 8.00016 3.13765C10.9402 3.13765 13.3335 5.53099 13.3335 8.47099C13.3335 11.411 10.9402 13.8043 8.00016 13.8043ZM8.00016 1.80432C4.3135 1.80432 1.3335 4.78432 1.3335 8.47099C1.3335 12.1577 4.3135 15.1377 8.00016 15.1377C11.6868 15.1377 14.6668 12.1577 14.6668 8.47099C14.6668 4.78432 11.6868 1.80432 8.00016 1.80432ZM9.72683 5.80432L8.00016 7.53099L6.2735 5.80432L5.3335 6.74432L7.06016 8.47099L5.3335 10.1977L6.2735 11.1377L8.00016 9.41099L9.72683 11.1377L10.6668 10.1977L8.94016 8.47099L10.6668 6.74432L9.72683 5.80432Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleOutline);
export default __webpack_public_path__ + "static/media/close-circle-outline.c74de4c5f1e9c6dc7060a131e59d9446.svg";
export { ForwardRef as ReactComponent };